import { GiPartyPopper } from "react-icons/gi"
import { SubformProps } from "."

const TIMEFRAME_NOTE =
  "Please note that this is an estimated timeline and actual processing times may vary."

const PREQUAL_PASS = "pass"

type SubmittedProps = Pick<SubformProps, "formData">

function hasPassedPrequal(formData: SubformProps["formData"]) {
  return (
    formData.prequalResult === PREQUAL_PASS ||
    formData.prequalResultCombined === PREQUAL_PASS
  )
}

function PendingReview() {
  return (
    <div className="alert alert-info" role="alert">
      Your application has been received and is pending review. A member of our banking
      team will reach out to you within 5-7 business days to discuss next steps. {TIMEFRAME_NOTE}
    </div>
  )
}

function PreQualifiedPending() {
  return (
    <div>
      Your application has been pre-qualified pending document verification. A member of
      our banking team will reach out within 5-7 business days to continue the application
      process. {TIMEFRAME_NOTE}
    </div>
  )
}

function ApprovedNextSteps() {
  return (
    <div className="mb-3">
      Your application has been submitted and is approved pending document verification. You
      should receive a Docusign package via email shortly. These documents must be signed to
      complete the application process. After signing, a Loan Officer will contact you within 5-7
      business days to review the application and finalize your loan. Please note that this is an
      estimated timeline and actual processing times may vary.
    </div>
  )
}

export const Submitted = ({ formData }: SubmittedProps) => {
  if (!hasPassedPrequal(formData)) {
    return <PendingReview />
  }

  const isApproved = Boolean(formData.envelopes?.length)

  return (
    <div>
      <div className="text-center">
        <GiPartyPopper size={100} className="text-success" aria-hidden="true" />
      </div>
      <div>
        <h4 className="text-center mb-4">Congratulations!</h4>
        {isApproved ? <ApprovedNextSteps /> : <PreQualifiedPending />}
      </div>
    </div>
  )
}